import OrderAction from './orderAction';
import { isValidEmail } from './utils';

class SendRequest extends OrderAction {
    get needs_selection() {
        return false;
    }

    get needs_confirm() {
        return true;
    }
}

export class SendPaymentRequest extends SendRequest {
    static NAME = 'send_payment_request';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    static condition(order) {
        return (
            ['reservation'].includes(order.status) &&
            order.attendee_count > order.attendees_deleted_count &&
            isValidEmail(order.buyer_email) &&
            order.origin !== 'weez_invitation' &&
            super.payment_plan_condition(order)
        );
    }

    static is_available({ feature_flags, event }) {
        return !['over', 'closed'].includes(event.status) && !event.removed && (feature_flags.includes('EO_MAJLINK') || feature_flags.includes('EO_PAYLINK'));
    }
}

export class SendUpdateInfoRequest extends SendRequest {
    static NAME = 'send_update_info_payment_request';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    static condition(order) {
        return (
            ['valid'].includes(order.status) &&
            order.attendee_count > order.attendees_deleted_count &&
            isValidEmail(order.buyer_email) &&
            order.origin !== 'weez_invitation' &&
            super.payment_plan_condition(order)
        );
    }

    static is_available({ feature_flags, event }) {
        return !['over', 'closed'].includes(event.status) && !event.removed && (feature_flags.includes('EO_MAJLINK') || feature_flags.includes('EO_PAYLINK'));
    }
}
